import React, { useEffect, useRef } from 'react';
import './City.css';
import cityExplorationWebp from '../../../assets/images/city_exploration.jpg';
import cityExplorationPng from '../../../assets/images/city_exploration.png';
import cityTradingWebp from '../../../assets/images/city_trading.jpg';
import cityTradingPng from '../../../assets/images/city_trading.png';
import cityUpgradesWebp from '../../../assets/images/city_upgrades.jpg';
import cityUpgradesPng from '../../../assets/images/city_upgrades.png';
import cityBossWebp from '../../../assets/images/city_boss.webp';
import cityBossPng from '../../../assets/images/city_boss.png';

const City = () => {
      const titleContainerRef = useRef(null);
      const squareRef = useRef(null);
      const featuresRef = useRef(null);
    
      useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && titleContainerRef.current) {
            titleContainerRef.current.classList.add('active');
          }
        }, { threshold: 0.99 });
        if (titleContainerRef.current) observer.observe(titleContainerRef.current);
        return () => observer.disconnect();
      }, []);
    
      useEffect(() => {
        const squareObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            document.querySelector('.blue-line-vertical-city')?.classList.add('active');
            document.querySelector('.blue-line-horizontal-city')?.classList.add('active');
          }
        }, { threshold: 0.5 });
    
        if (squareRef.current) squareObserver.observe(squareRef.current);
        return () => squareObserver.disconnect();
      }, []);

      useEffect(() => {
        const featuresObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            const features = document.querySelectorAll('.feature-item');
            features.forEach((feature, index) => {
              setTimeout(() => {
                feature.classList.add('fade-in');
              }, index * 200); // 200ms delay between each card
            });
          }
        }, { threshold: 0.5});
    
        if (featuresRef.current) featuresObserver.observe(featuresRef.current);
        return () => featuresObserver.disconnect();
      }, []);
    
  return (
    <div className="city-container ">
      <div className="blue-line-vertical-city"></div>
      <div className="blue-line-horizontal-city"></div>
        <div className="title-container" ref={titleContainerRef} style={{ height: '55px', top: '5px' }}>
          <h1 className="title-font" >Venture Above Burrow 11.<span className="cursor">|</span></h1>
          <div ref={squareRef} className="blue-square"></div>
          <div className="digital-lines" ></div>
        </div>

      <div className="features-grid" ref={featuresRef}>
        <div className="feature-item">
          <h3 className="fns-title-font">Free Exploration</h3>
          <div className="deck-image">
            <picture>
              <source srcSet={cityExplorationWebp} type="image/webp" />
              <img src={cityExplorationPng} alt="Free Exploration" />
            </picture>
          </div>
          <p>Discover hidden treasures and face unique challenges across the city.</p>
        </div>

        <div className="feature-item">
          <h3 className="fns-title-font">Strategic Trading</h3>
          <div className="deck-image">
            <picture>
              <source srcSet={cityTradingWebp} type="image/webp" />
              <img src={cityTradingPng} alt="Strategic Trading" />
            </picture>
          </div>
          <p>Exchange salvage for powerful cards with the Merchant.</p>
        </div>

        <div className="feature-item">
          <h3 className="fns-title-font">Upgrade System</h3>
          <div className="deck-image">
            <picture>
              <source srcSet={cityUpgradesWebp} type="image/webp" />
              <img src={cityUpgradesPng} alt="Upgrade System" />
            </picture>
          </div>
          <p>Enhance your drone and cards at Workshops.</p>
        </div>

        <div className="feature-item">
          <h3 className="fns-title-font">Boss Encounters</h3>
          <div className="deck-image">
            <picture>
              <source srcSet={cityBossWebp} type="image/webp" />
              <img src={cityBossPng} alt="Boss Encounters" />
            </picture>
          </div>
          <p>Defeat each area's Boss and descend down the city until you come back home!</p>
        </div>
      </div>
      <div className="blue-line-vertical-horizontal-city"></div>
    </div>
  );
};

export default City;


